import {Paper} from "@mui/material";
import {useCallback, useState} from "react";
import GlenSnackBar from "@/components/GlenSnackBar.tsx";
import MainDisplayContainer from "@/components/Layout/MainDisplayContainer.tsx";
import {LoggedOutHeader} from "@/components/Navigation/LoggedOutHeader.tsx";
import RegisterCommunityMemberForm from "../components/Forms/RegisterCommunityMemberForm";
import NoticeProvider from "../components/Providers/NoticeProvider";

export const signInError = "Invalid Student ID or Birth Date";

const RegisterCommunityMember = () => {
    const [showAlert, setShowAlert] = useState<boolean>(false);

    const handleClearAlert = useCallback(async () => {
        setShowAlert(false);
    }, [setShowAlert]);

    return (
        <NoticeProvider>
            <LoggedOutHeader mode={"instructor"} />
            <MainDisplayContainer>
                <Paper elevation={3} sx={{p: 4, width: "100%", mb: 2}}>
                    <GlenSnackBar
                        onClose={handleClearAlert}
                        show={showAlert}
                        severity={"error"}
                        message={signInError}
                    />
                    <RegisterCommunityMemberForm />
                </Paper>
            </MainDisplayContainer>
        </NoticeProvider>
    );
};

export default RegisterCommunityMember;
